import React, { useContext } from 'react';
import {
    Anchor,
    Avatar,
    Box,
    Button,
    Header,
    Layer,
    Nav,
    ResponsiveContext,
    Text
} from "grommet";
import { Analytics, Catalog, Close, Home, Upload, User } from 'grommet-icons';

const SidebarHeader = ({ setLoggedIn, setView, setShowMenuLayer, user }) => {
    return (
        <Box
            align='start'
            border={{ side: 'bottom'}}
            gap='medium'
            flex={false}
            pad={{ top: 'small', bottom: 'medium' }}
        >
            <Box gap='xsmall'>
                {user.profilePicture ? <Avatar margin={{bottom: 'xsmall'}} flex={false} src={user.profilePicture}/> : <Avatar margin={{bottom: 'xsmall'}} flex={false}><User/></Avatar>}
                <Anchor>{user.username}</Anchor>
                <Text>{user.firstName} {user.lastName}</Text>
            </Box>
            <Button
                label="Sign Out"
                onClick={() => {
                    setLoggedIn(false);
                    setView('signIn');
                    setShowMenuLayer(false);
                }}
            />
        </Box>
    )
}

const MenuLayer = ({ setShowMenuLayer, setView, setLoggedIn, loggedIn, user }) => {
    const size = useContext(ResponsiveContext);
    const pad = {
        horizontal: 'medium',
        vertical: 'small'
    };

    return (
        <Layer
            full={!['xsmall', 'small'].includes(size) ? 'vertical' : true}
            modal={false}
            onClickOutside={() => setShowMenuLayer(false)}
            onEsc={() => setShowMenuLayer(false)}
            position={!['xsmall', 'small'].includes(size) ? 'left' : undefined}
        >
            <Box
                fill='vertical'
                width={!['xsmall', 'small'].includes(size) ? 'medium' : undefined}
                elevation='large'
            >
                <Header pad={pad}>
                    <Button
                        a11yTitle={'You are in a navigation layer. To close this layer, press Enter'}
                        icon={<Close />}
                        onClick={() => setShowMenuLayer(false)}
                        autoFocus
                    >
                    </Button>
                </Header>
                <Box pad={pad} flex gap='medium' overflow='auto'>
                    { loggedIn && (
                        <SidebarHeader
                            setLoggedIn={setLoggedIn}
                            setView={setView}
                            setShowMenuLayer={setShowMenuLayer}
                            user={user}
                        />
                    )}
                    <Button
                        icon={<Home />}
                        label="Explore"
                        plain={true}
                        alignSelf='start'
                        onClick={() => {
                            setShowMenuLayer(false);
                            setView('feed');
                        }}
                    />
                    { loggedIn && (
                        <Box flex gap='medium'>
                            <Button
                                icon={<Upload />}
                                label="Upload"
                                plain={true}
                                alignSelf='start'
                                onClick={() => {
                                    setShowMenuLayer(false);
                                    setView('upload');
                                }}
                            />
                            <Button
                                icon={<Catalog />}
                                label="My Files"
                                plain={true}
                                alignSelf='start'
                                onClick={() => {
                                    setShowMenuLayer(false);
                                    setView('myFiles');
                                }}
                            />
                            <Button
                                icon={<Analytics />}
                                label="Analytics"
                                plain={true}
                                alignSelf='start'
                                onClick={() => {
                                    console.log('show analytics page')
                                    setShowMenuLayer(false);
                                    setView('analytics');
                                }}
                            />
                        </Box>
                    )}
                    <Box flex />
                    <Nav border={{side: 'top'}} pad={pad}>
                        <Button
                            label="About"
                            plain={true}
                            onClick={() => {
                                setView('about');
                                setShowMenuLayer(false);
                            }}
                        />
                        <Button
                            label="Contact"
                            plain={true}
                            onClick={() => {
                                setView('contact');
                                setShowMenuLayer(false);
                            }}
                        />
                    </Nav>
                </Box>
            </Box>
        </Layer>
    )
}

export default MenuLayer;